import { Upload, Button, message } from "antd"
import { UploadOutlined } from '@ant-design/icons';
import UploadThumbnailWidget from './uploadThumbnailWidget.js'

export default function UploadWidget({ type, object, onPictureUpload }) {
  const backendUrl = process.env.REACT_APP_BACKEND_URL;

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      message.error('You can only upload JPG/PNG file!');
      return false;
    }
    const isValidSize = file.size / 1024 / 1024 < 1;
    if (!isValidSize) {
      message.error('Image must be smaller than 1MB!');
      return false;
    }
    return true;
  };

  const handleChange = ({ file }) => {
    if (file.status === 'done') {
      message.success("Successfully uploaded file(s).");
      if (onPictureUpload) onPictureUpload();
    } else if (file.status === 'error') {
      message.error('Upload failed.');
    }
  };

  return (
    <div>
      <Upload
        name="file"
        action={`${backendUrl}/admin/content/update/${type}/image/${object?.id}`}
        multiple
        showUploadList={true}
        beforeUpload={beforeUpload}
        onChange={handleChange}
        headers={{
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }}
      >
        <Button style={{ marginTop: "10px" }} icon={<UploadOutlined />}>
          Upload
        </Button>
      </Upload>
      <UploadThumbnailWidget type={type} object={object}></UploadThumbnailWidget>
    </div>
  );
}
